import React from "react";
import { Link } from "react-router-dom";
import "../coleccionesLanding.css";

const categories = [
  { name: "Rodilleras", image: "../Colleciones/rodis-sbd-coll.jpg", link: "/rodilleras", big: true },
  { name: "Rodilleras Rígidas", image: "../Colleciones/rig-coll.webp", link: "/rodilleras-rig" },
  { name: "Cinturones", image: "../Colleciones/cint-coll.jpg", link: "/cinturones" },
  { name: "Muñequeras", image: "../Colleciones/muñ-coll.jpg", link: "/muñequeras" },
  { name: "Calzado", image: "../Colleciones/calz-coll.webp", link: "/calzado" },
  { name: "Singlets", image: "../Colleciones/sing-a7-coll.jpg", link: "/singlets", big: true },
];

const HomeCollections = () => {
  return (
    <section className="home-categories">
      <h3 className="home-categories-title">Explorar por categoría</h3>

      <div className="home-categories-grid">
        {categories.map((c, i) => (
          <Link
            key={i}
            to={c.link}
            className={`home-category-card ${c.big ? "big" : ""}`}
          >
            <div
              className="home-category-bg"
              style={{ backgroundImage: `url(${c.image})` }}
            >
              <div className="home-category-overlay">
                <h2>{c.name}</h2>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default HomeCollections;
